import {
  ACTIVATE_NOTIFICATION,
  DE_ACTIVATE_NOTIFICATION
} from '../constants/actionTypes';

const NOTIFICATION_TIME_LIMIT = 10000;

export const deAcitavteNotification = () => dispatch => {
  dispatch({ type: DE_ACTIVATE_NOTIFICATION });
};

export const acitavteNotification = (
  title,
  description,
  isFixed = false
) => dispatch => {
  dispatch({ type: ACTIVATE_NOTIFICATION, payload: { title, description } });

  if (!isFixed) {
    setTimeout(() => {
      dispatch({ type: DE_ACTIVATE_NOTIFICATION });
    }, NOTIFICATION_TIME_LIMIT);
  }
};



// WEBPACK FOOTER //
// ./src/actions/Notification.js